"use strict";
/*
 * Created on 01 15 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");
/**
 * Converter for {@link ValidationResult validation result} entity.
 *
 * @author JMe
 */


var ValidationResultConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ValidationResultConverter, _DataObjectConverter_);

  function ValidationResultConverter() {
    _classCallCheck(this, ValidationResultConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValidationResultConverter).apply(this, arguments));
  }

  return ValidationResultConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ValidationResultConverter = ValidationResultConverter;